import { isNil } from 'lodash';
import { RouteName, RouteParamMapping, useNavigator } from '@shared/util/navigation';

export function useOpenEntityById(baseNavigationPath: string, workflowTemplateId: string) {
  const navigator = useNavigator();

  return (entityId: string, navigationViewTemplateId: string | null) => {
    let navEndpoint: RouteName = 'CardDetails';
    const navOptions: RouteParamMapping['CardDetails'] = {
      cardId: entityId,
      channelSlug: baseNavigationPath,
      workflowTemplateId: workflowTemplateId,
    };

    if (!isNil(navigationViewTemplateId)) {
      navEndpoint = 'CardUpdate';
      navOptions.templateSlug = navigationViewTemplateId;
    }
    navigator.navigate(navEndpoint, navOptions);
  };
}
